import React from 'react';
import _isNil from 'lodash/isNil';
import PropTypes from 'prop-types';
// Core components
import TextField from 'components/core/TextField';

const NumberInputField = React.forwardRef(({
  min, max, sanitizer, onChange, ...otherProps
}, ref) => {
  const handleBlur = (value) => {
    let sanitizedValue = sanitizer(value);
    if (!_isNil(min) && sanitizedValue < min) {
      sanitizedValue = min;
    }
    if (!_isNil(max) && sanitizedValue > max) {
      sanitizedValue = max;
    }
    onChange(sanitizedValue);
  };

  return (
    <TextField
      onChange={onChange}
      onBlur={handleBlur}
      ref={ref}
      {...otherProps}
    />
  );
});

NumberInputField.displayName = 'NumberInputField';

NumberInputField.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  sanitizer: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

NumberInputField.defaultProps = {
  min: null,
  max: null,
};

module.exports = NumberInputField;



// WEBPACK FOOTER //
// ./components/inputFields/NumberInputField.js